import { render, staticRenderFns } from "./RiddleQuestion.vue?vue&type=template&id=6a8784cc&scoped=true"
import script from "./RiddleQuestion.vue?vue&type=script&lang=ts"
export * from "./RiddleQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RiddleQuestion.vue?vue&type=style&index=0&id=6a8784cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8784cc",
  null
  
)

export default component.exports